import { render } from "./QuizView.vue?vue&type=template&id=06ca227c"
import script from "./QuizView.vue?vue&type=script&lang=js"
export * from "./QuizView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__